$ = require 'jquery'
_ = require 'underscore'
Confirm = require 'views/lib/confirm'
Hearsay = require 'hearsay'
PopOver = require 'views/lib/pop-over'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginSectionRemoveAttachmentsView = require 'views/plugin/plugin-section-remove-attachments-view'
PluginView = require 'views/plugin/plugin-view'
Promise = require 'bluebird'
pluginValidators = require 'lib/util/plugin-validators'
sandboxParams = require 'data/plugin-iframe-sandbox'
t = require('views/internal/teacup-with-helpers')('plugin_section')
track = require 'debug/track'
Util = require 'lib/util'

template = t.renderable (data) ->
  { canRemove, content } = data
  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title.window-module-title-no-divider', ->
      t.span '.window-module-title-icon.icon-lg.plugin-section-icon.js-icon'
      t.h3 '.u-inline-block.plugin-section-title.js-title'
      t.div '.window-module-title-options', ->
        if canRemove
          t.a '.quiet.js-remove', { href: '#' }, ->
            t.format 'remove'
            return
        return
      return

    if content.type == 'iframe' && pluginValidators.isValidUrlForIframe(content.url)
      { url, height } = content
      if !pluginValidators.isValidHeight(height)
        height = undefined
      t.div '.u-gutter', ->
        t.iframe '.plugin-iframe.plugin-section',
          allow: 'microphone; camera'
          sandbox: sandboxParams
          src: url
          style: t.stylify
            height: if height then "#{ height }px;" else undefined
        return
    return
  return

module.exports = class PluginSectionView extends PluginView
  initialize: ->
    @section = new Hearsay.Slot(null)

  renderOnce: ->
    section = @section.get()
    if !section?
      throw Error('updateSection not called before render')

    @$el.html(template(Object.assign({}, section, canRemove: @model.editable())))

    @subscribe @section, (latestSection) =>
      Promise.resolve(_.result(latestSection, 'title'))
      .then (title) =>
        @$('.js-title').text(title)
      .catch PluginRunner.Error.Timeout, (->)

      Promise.resolve(_.result(latestSection, 'icon'))
      .then (icon) =>
        icon_url = t.addRecolorParam(icon, "?color=999")
        @$('.js-icon').css('background-image', t.urlify(icon_url))
      .catch PluginRunner.Error.Timeout, (->)

    @initIFrames(@model.getBoard(), @model, @section)

    @

  updateSection: (section) ->
    @retain(section)
    @section.set(section)

  events:
    'click .js-remove': 'confirmRemove'

  confirmRemove: (e) ->
    Util.stop(e)

    section = @section.get()

    if section.claimed.length == 1
      model = @model.attachmentList.get(section.claimed[0].id)
      Confirm.toggle 'remove attachment',
        elem: @$(e.currentTarget)
        model: model
        confirmBtnClass: 'negate'
        fxConfirm: (e) =>
          model.destroy()
          track("Attachment", "Delete Attachment", model.getType())
    else
      PopOver.toggle
        elem: $(e.currentTarget)
        view: new PluginSectionRemoveAttachmentsView({ @model, section })

    return



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-section-view.coffee